import { useLocation } from 'react-router-dom';

import CompleteIcon from '@/assets/img/icon/complete.svg';

import * as S from './style';

const CompleteFindId = () => {
	const location = useLocation();
	const { member_id } = location.state as { member_id: string };
	return (
		<S.FormContainer>
			<S.Container>
				<S.ImgBox>
					<img src={CompleteIcon} alt="아이디 찾기 완료" />
				</S.ImgBox>
				<S.Title>
					회원님의 아이디는 <strong>{member_id}</strong> 입니다.
				</S.Title>
			</S.Container>
			<S.NextButton type="button" onClick={() => window.location.replace('/auth/login')}>
				로그인 하러가기
			</S.NextButton>
		</S.FormContainer>
	);
};
export default CompleteFindId;
